export default __webpack_public_path__ + "static/media/pdf_icon.f8e93bb4.svg";